import type { Route } from '@angular/router';
import type { Permission } from '@core/config/permissions.config';
import { permissionGuard } from '@core/guards/permission.guard';

/**
 * Gate a workspace route by a capability. Hiding a nav item is not enough — a
 * role that lacks the capability could still deep-link to the page — so every
 * role-restricted destination also runs `permissionGuard`, which reads
 * `data.permission` and redirects to the workspace home when `can()` is false.
 * The capability is resolved against the active type+role, so one key works
 * across workspace types (a Manager blocked from `assessment.view` in education
 * is unaffected in a business workspace that grants it).
 */
export function needs(
  permission: Permission,
  extraData: Record<string, unknown> = {},
): Pick<Route, 'canActivate' | 'data'> {
  return { canActivate: [permissionGuard], data: { ...extraData, permission } };
}
